import Button from "componentsv2/button/Button";

function ButtonForm(props) {
  const {
    name,
    label,
    disabled,
    color,
    iconRight,
    iconLeft,
    style = null,
    handleButton,
    invisible,
    loading = true,
    record,
  } = props;
  // const { loadingBtn, setButtonLoading } = useBtnLoading();
  if (invisible?.(name, record)) {
    return null;
  }

  async function onClick(e) {
    e.preventDefault();
    // This has bugged @victor
    // if (loading) {
    //   setButtonLoading(true);
    // }
    await handleButton(name);
  }

  const _color = color ?? "green";
  // loading={loading ? loadingBtn : false}
  return (
    <div id="button-form" className="py-4">
      <Button
        key={name}
        name={name}
        onClick={onClick}
        color={_color}
        content={label}
        disabled={disabled}
        iconRight={iconRight || false}
        iconLeft={iconLeft || false}
        style={style}
      />
    </div>
  );
}

export default ButtonForm;
